module.exports = __webpack_public_path__ + "5c51a9330afa6a75d867a53e53f18637.svg";